<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    transition(name="fade")
      .content.search(v-if='!loading')
        .grid
          .col-4_xs-12.titles
            h2.h-l
              | search
          .col-8_xs-12.results(v-if="results")
            .grid
              .col-8_xs-12
                h2.h-l.result-total {{ total }} results for {{ query }}
              .col-8_xs-12(v-for="item in loadedData")
                h3.h-sm.item-category(:class="formatCat(item)") {{ item.displayCategory }}
                router-link(:to="item.url.replace('https://caamuseum.org', '')")
                  h2.h-m(v-html="item.title")
                  p.h-sxx(v-if="item.text" v-html="`${item.text.substring(0,180)}...`")
          .col-8_xs-12.results(v-else)
            h3.sorry.h-m
              | Sorry!
            p
              | We couldn't find any results.
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import algoliasearch from 'algoliasearch'

export default {
  name: 'search',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      loading: false,
      loadedData: {},
      totalResults: 0,
      // url: 'http://localhost:8888/caam_live/api/search?query='
      url: 'https://caamuseum.org/api/search?query='
    }
  },

  created () {
    this.search()
  },

  computed: {
    query () {
      return this.$route.query.query
    },

    client () {
      return algoliasearch(
        'EWY5Z282WH',
        'd3fd039ebaf191178cdaedbd7f5c51b3'
      )
    },

    algoliaQuery () {
      return [
        {
          indexName: 'program',
          query: this.query,
          params: {
            hitsPerPage: 50
          }
        },
        {
          indexName: 'article',
          query: this.query,
          params: {
            hitsPerPage: 50
          }
        },
        {
          indexName: 'exhibition',
          query: this.query,
          params: {
            hitsPerPage: 50
          }
        },
        {
          indexName: 'info',
          query: this.query,
          params: {
            hitsPerPage: 50
          }
        },
        {
          indexName: 'infoSubpage',
          query: this.query,
          params: {
            hitsPerPage: 50
          }
        },
        {
          indexName: 'articleIndex',
          query: this.query,
          params: {
            hitsPerPage: 50
          }
        },
        {
          indexName: 'index',
          query: this.query,
          params: {
            hitsPerPage: 50
          }
        }
      ]
    },

    results () {
      return this.loadedData.length > 0
    },

    key () {
      return 'search'
    }
  },

  methods: {
    searchMulti () {
      this.loading = true
      this.client.multipleQueries(this.algoliaQuery).then(({ results }) => {
        console.log(results)
        const hits = results.map((r) => {
          return r.hits
        })
        this.total = results.reduce((a, v) => {
          return a + parseInt(v.nbHits)
        }, 0)
        const hitsSorted = hits.sort((a, b) => {
          return b.length - a.length
        })
        this.loadedData = hitsSorted.flat()
        this.loading = false
      })
    },

    search () {
      this.loading = true
      const index = this.client.initIndex('main')
      index.search(this.query, {
        hitsPerPage: 50
      }).then(({ hits }) => {
        this.loadedData = hits
        this.total = hits.length
        this.loading = false
      })
    },

    formatCat (item) {
      return item.displayCategory === '600state' ? 'sixhundredstate' : item.displayCategory
    }
  },

  watch: {
    $route () {
      this.search()
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_variables'
  .content
    &.search
      .item-category
        &.visit
          color: $visit
        &.programs
          color: $programs
        &.exhibitions
          color: $exhibitions
        &.collection
          color: $collections
        &.library
          color: $library
        &.sixhundredstate
          color: $learn
        &.learn
          color: $learn
        &.support
          color: $support
        &.about
          color: $about
      .result-total
        display: block !important
        margin-bottom: 6rem
      .results
        margin-top: 0
        h2
          padding-top: 0.4rem
          display: inline
          border-bottom: solid 2px #FFF
      h2, h3, h4, a
        padding: 0
        margin: 0
      a
        &:hover h3
          border-bottom: solid 2px #000
</style>



// WEBPACK FOOTER //
// Search.vue?1b3a4ce6